module.exports = __webpack_public_path__ + "static/img/Lei-li-formal-640w.fe4e5cb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Lei-li-formal-640w.jpeg
// module id = 803
// module chunks = 5